import './subscriptionWidget.scss'
import { Subscription } from '@/features/settings'

export type SubscriptionWidgetProps = {}
export const SubscriptionWidget = ({}: SubscriptionWidgetProps) => {
    return (
        <div className="subscription-widget">
            <h3 className="subscription-title">Тариф и оплата</h3>
            <Subscription />
        </div>
    )
}
